import React, { useRef, useState, useCallback, useEffect } from "react";
import { FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";
import { FaYoutube, FaInstagram } from "react-icons/fa";
import TitleHeader from "../TitleHeader";
import { appApiHandler } from "../../../../api/appApiHandler";
import { getOptimizedUrl } from "../../../../constants/globalFunction";
import "./SocialShowcase.css";

const SocialShowcase = () => {
  const scrollerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [socialVideos, setSocialVideos] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSocialMedia = async () => {
    setLoading(true);
    try {
      const response = await appApiHandler.getSocialMedia({ page: 1, limit: 20 });
      if (response?.status === 200) {
        setSocialVideos(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching social media:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSocialMedia();
  }, []);

  const updateArrows = useCallback(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const { scrollLeft, scrollWidth, clientWidth } = scroller;
    setCanScrollLeft(scrollLeft > 4);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 4);
  }, []);

  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    updateArrows();
    scroller.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);
    return () => {
      scroller.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, [updateArrows, socialVideos]);

  const scrollBy = (direction) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const card = scroller.querySelector(".social-card");
    const step = card ? card.offsetWidth + 20 : 300;
    scroller.scrollBy({ left: direction * step * 2, behavior: "smooth" });
  };

  const getEmbedUrl = (video) => {
    const link = video.url || video.link;
    const type = video.social_type || video.type;
    console.log('insta thumb');
    if (type === "instagram") {
      const baseUrl = link.split('?')[0];
      console.log('insta thumb in');
      console.log(`'hello ',${baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'}embed`);
      return `${baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'}embed`;
    } else if (type === "youtube") {
      const videoId = link.split('/shorts/')[1]?.split('?')[0];
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    }
    return link;
  };

  const getThumbnailUrl = (video) => {
   
    let thumb =
      video.thumbnail;
      
    if (thumb) {

      // Clean the path to point to the public storage URL
    
      const finalUrl = getOptimizedUrl(thumb);
      return finalUrl;
    }

    // 2. Fallback logic if backend thumbnail is missing
    const link = video.url || video.link;
    const type = video.social_type || video.type;

    if (type === "youtube" && link) {
      const videoId =
        link.split("/shorts/")[1]?.split("?")[0] ||
        link.split("v=")[1]?.split("&")[0];
      if (videoId) return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    }

    return "";
  };

  if (!loading && socialVideos.length === 0) return null;

  return (
    <section className="social-showcase">
      <TitleHeader title="Social Showcase" subtitle="Follow us on Social Media" />

      <div className="social-showcase__container">
        {canScrollLeft && (
          <button className="social-nav prev" onClick={() => scrollBy(-1)}>
            <FaChevronLeft />
          </button>
        )}

        <div className="social-scroller" ref={scrollerRef}>
          {socialVideos.map((video) => {
            const type = video.social_type || video.type;
            return (
              <div
                key={video.id || video._id}
                className="social-card"
                onClick={() => setSelectedVideo(video)}
              >
                <div className="social-card__media">
                  <img
                    src={getThumbnailUrl(video)}
                    alt="Social Media Reel"
                    className="social-card__thumb"
                    loading="lazy"
                  />
                  {/* Dark overlay + platform icon */}
                  <div className="social-card__overlay">
                    <div className="social-card__platform-icon">
                      {type === "youtube" ? (
                        <FaYoutube className="social-card__yt-icon" />
                      ) : (
                        <FaInstagram className="social-card__insta-icon" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {canScrollRight && (
          <button className="social-nav next" onClick={() => scrollBy(1)}>
            <FaChevronRight />
          </button>
        )}
      </div>

      {selectedVideo && (
        <div className="video-modal-overlay" onClick={() => setSelectedVideo(null)}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setSelectedVideo(null)}>
              <FaTimes />
            </button>

            <iframe
              className="video-modal-iframe"
              src={getEmbedUrl(selectedVideo)}
              title="Social Media Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default SocialShowcase;
